import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Inventory from './index';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default function InventoryProvider() {
  return (
    <QueryClientProvider client={queryClient}>
      <Inventory />
    </QueryClientProvider>
  );
}
